import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import {
  IProductUnregulated,
  PRODUCTS_UNREGULATED_TTL_ES
} from '../../product-unregulated.interface';
import { ProductUnregulatedService } from '../../product-unregulated.service';

@Component({
  selector: 'pg-product-unregulated-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class ProductUnregulatedSelectComponent extends SelectTemplate {
  constructor(private serviceBase: ProductUnregulatedService) {
    super(PRODUCTS_UNREGULATED_TTL_ES, serviceBase);
  }

  async ngOnInit() {
    this.table.settings = {
      title: PRODUCTS_UNREGULATED_TTL_ES,
      columns: [
        { header: 'Código', field: 'code' },
        { header: 'Descripción', field: 'name' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IProductUnregulated[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
